import PermissionCanonicalMixin from "@/assets/plugins/mps-common/permission-canonical/PermissionCanonicalMixin";

export default {
    install(Vue, options) {
        Vue.mixin(PermissionCanonicalMixin);
    }
}